<template>
  <div :class="outerClasses">
    <div :class="innerClasses" v-if="display">
      <el-alert class="player-setup-error" :title="message" type="error" :closable="false" show-icon>
          <slot />
      </el-alert>
    </div>
  </div>
</template>

<script src="./player-setup-form-error.js"></script>
<style lang="scss" src="./player-setup-form-error.scss"></style>
